import {
    URLASSOLUTO,
    URLASSOLUTOISTITUZIONALE,
    CURRENTROUTENAME,
    VIEWNAME,
    TEMPLATEID,
    NONCE,
} from "./variables";
import Swal from "./sweetalert2";
import buttoned from "./quantity-button";

import "./jquery.flexdatalist"; // messo script localmente perchè non funziona da node_modules...

$(document).ready(function () {
    $('[data-bs-toggle="tooltip"]').each(function () {
        new Tooltip($(this), {
            placement: "top",
        });
    });

    $("body").on("change", ".cambiaIndirizzoConsegna", function (e) {
        let idindirizzo = $(this).val();
        $(".boxIndirizzo .card-body").removeClass("selected");
        $(this)
            .closest(".boxIndirizzo")
            .find(".card-body")
            .addClass("selected");

        $(".boxIndirizzo .rimuoviIndirizzo").removeClass("d-none");
        $(this)
            .closest(".boxIndirizzo")
            .find(".rimuoviIndirizzo")
            .addClass("d-none");

        $(".boxIndirizzo .text-success").addClass("d-none");
        $(this)
            .closest(".boxIndirizzo")
            .find(".text-success")
            .removeClass("d-none");
        $("#delivery_id").val(idindirizzo);

        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            url: URLASSOLUTO + "/change-address/",
            method: "POST",
            dataType: "html",
            data: { idindirizzo: idindirizzo },
            dataType: "html",
        }).done(function (result) {
            let obj = JSON.parse(result);
            let objResponse = obj.data;
            console.log(objResponse);
            if (objResponse.status == "OK") {
                let title = objResponse.title;
                let icon = objResponse.icon;
                let message = objResponse.message;

                // mostro swal OK
                Swal.fire({
                    title: title,
                    html: message,
                    icon: icon,
                }).then((result) => {
                    // Reload the Page
                    location.reload();
                });
            } else {
                Swal.fire({
                    html: `${translation["javascript-errore-eliminazione-indirizzo"]}`,
                    title: `${translation["javascript-elaborazione-fallito"]}`,
                    icon: "warning",
                });
            }
        });
    });

    $("body").on("click", ".checkout", function (e) {
        var targetform = $(this).data("target");
        var paymenttype = $(this).data("paymenttype");
        if (!$("#formCheckout input[name='typerequest']:checked").val()) {
            Swal.fire({
                html: `${translation["javascript-errore-seleziona-typerequest"]}`,
                title: `${translation["javascript-elaborazione-fallito"]}`,
                icon: "warning",
            });
            $("#formCheckout").addClass('was-validated'); // aggiungo classe was-validated
        } else {

            var formvalues = $("#formCheckout").serialize();

            Swal.fire({
                title: `${translation["javascript-attendere-prego"]}`,
                html: `${translation["javascript-aggiunta-elaborazione-dati"]}`,
                showConfirmButton: false,
                backdrop: false,
                customClass: {
                    container: "swalspinner_messages",
                },
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });

            $.ajax({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                },
                url: URLASSOLUTO + "/checkoutExe/",
                method: "POST",
                dataType: "html",
                data: { formvalues: formvalues, paymenttype: paymenttype },
                dataType: "html",
            }).done(function (result) {
                let obj = JSON.parse(result);
                let objResponse = obj.data;
                console.log(objResponse);
                if (objResponse.status == "OK") {
                    if (objResponse.action == "redirect") {
                        document.location.href = objResponse.url;
                    } else {
                        console.log("#" + targetform);
                        if (
                            "formPayPal" == targetform ||
                            "formNexi" == targetform
                        ) {
                            $("." + targetform + "button").trigger("click");
                        } else {
                            $("." + targetform).submit();
                        }
                    }
                } else {
                    Swal.fire({
                        html: `${translation["javascript-invio-pagamento-fallito"]}`,
                        title: `${translation["javascript-elaborazione-fallito"]}`,
                        html: objResponse.title,
                        icon: "warning",
                    }).then((result) => {
                        // Reload the Page
                        location.reload();
                    });
                }
            });
        }
    });

    $("body").on("click", ".rimuoviIndirizzo", function (e) {
        let idindirizzo = $(this).data("idindirizzo");
        let boxindirizzo = $(this).closest(".boxIndirizzo");

        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            url: URLASSOLUTO + "/remove-address/",
            method: "POST",
            dataType: "html",
            data: { idindirizzo: idindirizzo },
            dataType: "html",
        }).done(function (result) {
            let obj = JSON.parse(result);
            let objResponse = obj.data;
            console.log(objResponse);
            if (objResponse.status == "OK") {
                let title = objResponse.title;
                let icon = objResponse.icon;
                let message = objResponse.message;

                // mostro swal OK
                boxindirizzo.remove();
                Swal.fire({
                    title: title,
                    html: message,
                    icon: icon,
                });
            } else {
                Swal.fire({
                    html: `${translation["javascript-errore-eliminazione-indirizzo"]}`,
                    title: `${translation["javascript-elaborazione-fallito"]}`,
                    icon: "warning",
                });
            }
        });
    });

    $("body").on("click", ".deleteCoupon", function (e) {
        e.preventDefault();
        Swal.fire({
            title: `${translation["javascript-attendere-prego"]}`,
            html: "Rimozione coupon",
            showConfirmButton: false,
            backdrop: false,
            customClass: {
                container: "swalspinner_messages",
            },
            onBeforeOpen: () => {
                Swal.showLoading();
            },
        });
        // mando idp a exeCarrello.php
        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            url: URLASSOLUTO + "/checkCouponCarrello/",
            method: "POST",
            data: { ajax: 1, delete: 1 },
            dataType: "html",
        }).done(function (result) {
            let objResponse = JSON.parse(result).data;
            let title = objResponse.title;
            let icon = objResponse.icon;
            let message = objResponse.message;
            let count = objResponse.count;
            if (objResponse.status == "OK") {
                //$(".carbadge").attr("data-count", count);
                $(".carbadge").html("(" + count + ")");
                if (count > 0) {
                    //if (objResponse.action == "checkout")
                    $(".shop-cart").replaceWith(objResponse.htmltablecarrello);

                    $(".right-cl-cart").replaceWith(
                        objResponse.htmlleftcarrello
                    );
                    buttoned();
                } else {
                    $(".containCarrello").html(objResponse.htmlemptycarrello);
                }
            }

            Swal.fire({
                title: title,
                html: message,
                icon: icon,
            });
        });
    });

    $("body").on("submit", "#formCoupon", function (e) {
        e.preventDefault();
        var coupon = $(this).find("#Coupon").val();

        // verifico se il coupon è valido e lo posso inserire con ajax e se valido lo inserisco già altrimenti lo tolgo
        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            url: URLASSOLUTO + "/checkCouponCarrello/",
            method: "POST",
            data: { ajax: 1, coupon: coupon },
            dataType: "html",
        }).done(function (result) {
            let objResponse = JSON.parse(result).data;
            let title = objResponse.title;
            let icon = objResponse.icon;
            let message = objResponse.message;
            let count = objResponse.count;
            if (objResponse.status == "OK") {
                //$(".carbadge").attr("data-count", count);
                $(".carbadge").html("(" + count + ")");
                if (count > 0) {
                    $(".shop-cart").replaceWith(objResponse.htmltablecarrello);
                    $(".right-cl-cart").replaceWith(
                        objResponse.htmlleftcarrello
                    );
                    buttoned();
                } else {
                    $(".containCarrello").html(objResponse.htmlemptycarrello);
                }
            }

            Swal.fire({
                title: title,
                html: message,
                icon: icon,
            });
        });
    });

    $("body").on("click", ".cancellaCarrello", function (e) {
        e.preventDefault();
        var idcarrello = $(this).data("idcarrello");
        if (idcarrello) {
            Swal.fire({
                title: `${translation["javascript-attendere-prego"]}`,
                html: `${translation["javascript-aggiunta-prodotto-carrello"]}`,
                showConfirmButton: false,
                backdrop: false,
                customClass: {
                    container: "swalspinner_messages",
                },
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });
            // mando idp a exeCarrello.php
            $.ajax({
                url: URLASSOLUTO + "/cambia-carrello/",
                method: "GET",
                data: { ajax: 1, deletequantity: 1, idcarrello: idcarrello },
                dataType: "html",
            }).done(function (result) {
                //console.log(result);

                let objResponse = JSON.parse(result).data;

                if (objResponse.status == "OK") {
                    let title = objResponse.title;
                    let icon = objResponse.icon;
                    let message = objResponse.message;
                    let count = objResponse.count;

                    //$(".carbadge").attr("data-count", count);
                    $(".carbadge").html("(" + count + ")");
                    if (count > 0) {
                        $(".shop-cart").replaceWith(
                            objResponse.htmltablecarrello
                        );
                        $(".right-cl-cart").replaceWith(
                            objResponse.htmlleftcarrello
                        );
                        buttoned();
                    } else {
                        $(".containCarrello").html(
                            objResponse.htmlemptycarrello
                        );
                    }
                    Swal.close();
                }
            });
        } else {
            Swal.fire({
                title: `${translation["javascript-errore-eliminazione-carrello"]}`,
                html: `${translation["javascript-elaborazione-fallito"]}`,
                type: "warning",
            });
        }
    });
    $("body").on("click", ".boxCarrello .changeToCart", function (e) {
        e.preventDefault();
        var quantity = $(this).parent().find("input");
        var delta = $(this).data("delta");
        var actualquantity = quantity.val();

        if (actualquantity != "0" || delta != "-1") {
            var itemTable = quantity.data("itemtable");
            Swal.fire({
                title: `${translation["javascript-attendere-prego"]}`,
                html: `${translation["javascript-modifica-prodotto-carrello"]}`,
                showConfirmButton: false,
                backdrop: false,
                customClass: {
                    container: "swalspinner_messages",
                },
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });

            // mando idp a exeCarrello.php
            $.ajax({
                url: URLASSOLUTO + "/cambia-carrello/",
                method: "GET",
                data: { ajax: 1, delta: delta, product_id: itemTable },
                dataType: "html",
            }).done(function (result) {
                let objResponse = JSON.parse(result).data;

                if (objResponse.status == "OK") {
                    // mostro swal OK
                    let title = objResponse.title;
                    let icon = objResponse.icon;
                    let message = objResponse.message;
                    let count = objResponse.count;
                    //$(".carbadge").attr("data-count", count);
                    $(".carbadge").html("(" + count + ")");

                    if (count > 0) {
                        $(".shop-cart").replaceWith(
                            objResponse.htmltablecarrello
                        );
                        $(".right-cl-cart").replaceWith(
                            objResponse.htmlleftcarrello
                        );
                        buttoned();
                    } else {
                        $(".containCarrello").html(
                            objResponse.htmlemptycarrello
                        );
                    }
                    Swal.close();
                }
            });
        }
    });

    $("body").on("change", '.boxCarrello input[name="qnt"]', function (e) {
        e.preventDefault();
        var quantity = $(this);
        var newquantity = quantity.val();
        if (newquantity > 0) {
            var itemTable = quantity.data("itemtable");
            Swal.fire({
                title: `${translation["javascript-attendere-prego"]}`,
                html: `${translation["javascript-modifica-prodotto-carrello"]}`,
                showConfirmButton: false,
                backdrop: false,
                customClass: {
                    container: "swalspinner_messages",
                },
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });

            // mando idp a exeCarrello.php
            $.ajax({
                url: URLASSOLUTO + "/cambia-carrello/",
                method: "GET",
                data: {
                    ajax: 1,
                    idcarrello: itemTable,
                    newquantity: newquantity,
                },
                dataType: "html",
            }).done(function (result) {
                //console.log(result);

                let objResponse = JSON.parse(result).data;

                if (objResponse.status == "OK") {
                    // mostro swal OK
                    let title = objResponse.title;
                    let icon = objResponse.icon;
                    let message = objResponse.message;
                    let count = objResponse.count;
                    //$(".carbadge").attr("data-count", count);
                    $(".carbadge").html("(" + count + ")");

                    if (count > 0) {
                        $(".shop-cart").replaceWith(
                            objResponse.htmltablecarrello
                        );
                        $(".right-cl-cart").replaceWith(
                            objResponse.htmlleftcarrello
                        );
                        buttoned();
                    } else {
                        $(".containCarrello").html(
                            objResponse.htmlemptycarrello
                        );
                    }
                    Swal.close();
                }
            });
        }
    });

    $("body").on("click", ".addToCart, .sendPreventivo", function (e) {
        e.preventDefault();
        // recupero idprodotto da aggiungere a carrello
        var myform = $(this).closest("form");

        var myformisvalid = false;
        if (myform[0].checkValidity()) myformisvalid = true;
        else myform[0].reportValidity();

        myform[0].classList.add("was-validated");
        if (!myformisvalid) {
            return;
        }

        var CARTADD = myform.attr("action");

        var addarticleinput = [];
        var articlecode = "";
        $('input[name^="addarticleinput"]').each(function () {
            articlecode = $(this).data("articlecode");
            if ($(this).val() == "") {
                Swal.fire({
                    title: `${translation["javascript-errore-inserimento-carrello"]}`,
                    html: `${translation["javascript-elaborazione-fallito"]}`,
                    icon: "warning",
                });
                return;
            } else {
                addarticleinput[articlecode] = $(this).val();
            }
        });

        var product_id = myform.find('input[name="product_id"]').val();

        if (product_id && Object.keys(addarticleinput).length > 0) {
            // preloader

            Swal.fire({
                title: `${translation["javascript-attendere-prego"]}`,
                html: `${translation["javascript-aggiunta-prodotto-carrello"]}`,
                showConfirmButton: false,
                backdrop: false,
                customClass: {
                    container: "swalspinner_messages",
                },
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });

            // mando idp a exeCarrello.php
            $.ajax({
                url: `${CARTADD}`,
                method: "POST",
                data: myform.serialize(),
                dataType: "html",
            }).done(function (result) {
                //console.log(result);
                console.log("qui");
                let objResponse = JSON.parse(result).data;

                if (objResponse.status == "OK") {
                    setTimeout(function () {
                        Swal.close();

                        // mostro swal OK
                        let title = objResponse.title;
                        let icon = objResponse.icon;
                        let message = objResponse.message;
                        let count = objResponse.count;
                        //$(".carbadge").attr("data-count", count);
                        $(".carbadge").html("(" + count + ")");

                        Swal.fire({
                            title: title,
                            html: message,
                            icon: icon,
                            padding: ".5rem",
                            backdrop: false,
                            reverseButtons: true,
                            confirmButtonText: `${translation["javascript-concludi-acquisto"]}`,
                            confirmButtonColor: "#0b0b0b",
                            confirmButtonClass: "confirm_carrello",
                            showCancelButton: true,
                            cancelButtonColor: "#ceeaf3",
                            cancelButtonText: `${translation["javascript-torna-prodotto"]}`,
                            cancelButtonClass:
                                "cancel_carrello grigio_chiaro1_cliente",
                            customClass: {
                                container: "swal_return_message",
                                actions: "swal_return_actions",
                            },
                        }).then((result) => {
                            // redirect a pagina carrello se clicca su confirm button
                            console.log(result);
                            if (result.value)
                                document.location.href = confirm_carrello;
                        });
                    }, 200);
                }
            });
        } else {
            Swal.fire({
                title: `${translation["javascript-errore-inserimento-carrello"]}`,
                html: `${translation["javascript-elaborazione-fallito"]}`,
                icon: "warning",
            });
        }
    });
});
